import { useTranslation } from "react-i18next";

import { UserAvatar } from "@components/Community";
import { useAuth } from "contexts/auth";

import { Text } from "@fragments";

import "./styles.scss";

export default function MemberCell({ member }) {
  const { t } = useTranslation("memberModals");
  const { user } = useAuth();

  const handle = member?.nickname ? `@${member.nickname}` : null;
  const email = member?.email?.address || member?.email || null;
  const secondary = handle || email;
  const isCurrentUser = !!user && !!member?.user_id && user.id === member.user_id;

  return (
    <div className="members-list-member-cell">
      <UserAvatar user={member} size={36} />
      <div className="members-list-member-cell__text">
        <Text.span contrast={8} weight={500}>
          {member?.username || "—"}
          {isCurrentUser && (
            <Text.span contrast={5} className="members-list-member-cell__you">
              {" "}
              {t("membersList.memberCell.you")}
            </Text.span>
          )}
        </Text.span>
        {secondary && (
          <Text.span contrast={5}>{secondary}</Text.span>
        )}
      </div>
    </div>
  );
}
